module.exports = __webpack_public_path__ + "static/media/inbox-out.68ed3c95.svg";